import React, { Component } from 'react'
import '../css/App.css'
import PieChart from './PieChart'
import {convertToPercentage, numFormat, convertToFixedTwo} from '../utils/helper'
import Progressbar from './ProgressBar'

class SummaryBox extends Component{

    render(){
        const summarydata = this.props.summaryData
        let  registeredVoters = summarydata.RegisteredVoters
        let  totalBallots = summarydata.TotalBallotsCast
        let  ballotPercentage = summarydata.RegisteredVoters>0 ? summarydata.TotalBallotsCast/summarydata.RegisteredVoters : 0
        //let  electionYear = new Date(summarydata.ElectionDate).getFullYear()
        let data = (totalBallots && summarydata.EarlyVotes != null && summarydata.ElectionDayVoters != null  && summarydata.AbsenteeSpecialBallotVotes != null )
                     ? [{
                       // title: electionYear=='2008' ? 'Provisional Turnout':'Early Votes',
                        title: 'Early Votes',
                        percentage: isNaN(summarydata.EarlyVotes/totalBallots) ? 0 : summarydata.EarlyVotes/totalBallots,
                        votes: summarydata.EarlyVotes,
                        color: '#726a95'  //set early votes color for chart ans text
                    },
                    {
                        //title: electionYear=='2008' ? 'Election Day Turnout':'Election Day Votes',
                        title: 'Election Day Votes',
                        percentage: isNaN(summarydata.ElectionDayVoters/totalBallots) ? 0 : summarydata.ElectionDayVoters/totalBallots,
                        votes: summarydata.ElectionDayVoters,
                        color: '#709fb0'  //set election day color for chart and text
                    },
                    {
                        //title: electionYear=='2008' ? 'Absentee Turnout':'Absentee and Special Ballot Votes',
                        title: 'Absentee and Special Ballot Votes',
                        percentage: isNaN(summarydata.AbsenteeSpecialBallotVotes/totalBallots) ? 0 : summarydata.AbsenteeSpecialBallotVotes/totalBallots,
                        votes: summarydata.AbsenteeSpecialBallotVotes,
                        color: '#849974' //set absebtee color for chart and text
                    }
                ] : null;
        if(this.props.useSpecialSummary === true){
            let tempTotal = summarydata.ElectionDayVoters||0 + summarydata.EarlyVotes||0;
            data = (totalBallots && summarydata.EarlyVotes != null && summarydata.ElectionDayVoters != null  && summarydata.AbsenteeSpecialBallotVotes != null )
                     ? [
                    {
                        //title: electionYear=='2008' ? 'Election Day Turnout':'Election Day Votes',
                        title: 'In-person voting (includes early voting and election day)',
                        percentage: isNaN(tempTotal/totalBallots) ? 0 : tempTotal/totalBallots,
                        votes: tempTotal,
                        color: '#709fb0'  //set election day color for chart and text
                    },
                    {
                        //title: electionYear=='2008' ? 'Absentee Turnout':'Absentee and Special Ballot Votes',
                        title: 'All Mail and Special Ballots',
                        percentage: isNaN(summarydata.AbsenteeSpecialBallotVotes/totalBallots) ? 0 : summarydata.AbsenteeSpecialBallotVotes/totalBallots,
                        votes: summarydata.AbsenteeSpecialBallotVotes,
                        color: '#849974' //set absebtee color for chart and text
                    }
                ] : null;
        }
        // console.log(data)
        // added a special text after the 'Total Ballots Counted', only effect when pros.showSpecialTextPrecint1 === true
        return (
        <div className='row summary' style={{padding:'20px 15px'}}>
           <div className="col-md-12 shadow-box" style={{fontWeight:'bold', marginBottom:'20px'}}>
                <div className='row'>
                    <div className="col-md-3 mb-4 mt-4 cuttingL" >
                        <div className='col leftStyle'>
                            Registered Voters
                        </div>
                        <div className='col'>
                            <p style={{background:'#1b4b6f',color:'white',width:'100%',borderRadius:'5px',fontSize:'30px',fontWeight:'bold', textAlign:'center', marginTop:'5px'}}> { numFormat(registeredVoters) }</p>
                        </div>
                    </div>
                    <div className='col-md-9 summary-right-wrapper'>
                        <div style={{display:'flex', height:'73px'}} className="col mb-4 mt-4">
                            <div className='leftStyle' style={{width:'100%', position:'relative'}}>
                                    {this.props.isUnofficial ? 'Total Ballots Counted:': 'Total Ballots Cast:'}
                                <span className='ml-3' >
                                    { numFormat(totalBallots )}
                                    {this.props.showSpecialTextPrecint1 && <span style={{color:'red'}}> (THIS PRECINCT INCLUDES 2,793 UOCAVA "Federal Only" BALLOTS)</span>}
                                </span>
                                <Progressbar style={{position:'absolute', bottom:'0px',height:'24px',width:'100%'}} width={convertToFixedTwo(ballotPercentage) } color={'#1b4b6f'} />
                            </div>
                            <div className='rightStyle text-center' style={{background:'#1b4b6f',color:'white',width:'100px',borderRadius:'5px 5px 0 0', height:'73px'}}>
                                <p style={{fontWeight:'bold',fontSize:'25px',position:'relative', top:'20px'}}>{ convertToFixedTwo(ballotPercentage)} 
                                    <span style={{fontSize:'12px'}}>%</span>
                                </p>
                            </div>
                        </div>
                    </div>

                </div>
            </div>
            { data && <PieChart chartdata={data} />}
        </div>
        )
    }
}

export default SummaryBox


// WEBPACK FOOTER //
// ./src/components/SummaryBox.js